export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent/Die Dozentin hat die Inhalte angemessen wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit Themen zu diskutieren.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin war fachlich kompetent.",
            },
            {
                id: 8,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 9,
                text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
            },
            {
                id: 10,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
            },
            {
                id: 11,
                text: "Das Lernziel wurde mir deutlich.",
            },
            {
                id: 12,
                text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
            },
            {
                id: 13,
                text: "Die Veranstaltung war übersichtlich und verständlich.",
            },
            {
                id: 14,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 15,
                text: "Das Thema der Veranstaltung interessiert mich.",
            },
            {
                id: 16,
                text: "Das Thema der Veranstaltung ist als solches relevant.",
            },
            {
                id: 17,
                text: "Ich habe das Gefühl durch die Veranstaltung Wichtiges gelernt zu haben.",
            },
        ],
    },
    {
        type: "bi",
        id: 2,
        items: [
            {
                id: 18,
                text: "Die Schwere des Stoffes war...",
            },
            {
                id: 19,
                text: "Der Umfang des Stoffes war...",
            },
            {
                id: 20,
                text: "Das Tempo der Veranstaltung war...",
            },
            {
                id: 21,
                text: "Die Anforderungen der Veranstaltung waren...",
            },
            {
                id: 22,
                text: "Insgesamt empfand ich die Veranstaltung als...",
            },
        ],
    },
    {
        type: "uni",
        id: 3,
        items: [
            {
                id: 23,
                text: "Die verwendeten Folien waren gut lesbar.",
            },
            {
                id: 24,
                text: "Die ausgehändigten Unterlagen (Folien/Wiederholungsfragen) waren/sind sehr hilfreich.",
            },
            {
                id: 25,
                text: "Es wurden genügend Beispiele / Fälle gegeben.",
            },
            {
                id: 26,
                text: "Es wurden genügend Materialien zur Vertiefung des Stoffes angeboten.",
            },
            {
                id: 27,
                text: "Folien und Skripte waren rechtzeitig zugänglich.",
            },
            {
                id: 28,
                text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
            },
            {
                id: 29,
                text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
            },
            {
                id: 30,
                text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
            },
            {
                id: 31,
                text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
            },
            {
                id: 32,
                text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
            },
            {
                id: 33,
                text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
            },
            {
                id: 34,
                text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
            },
            {
                id: 35,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 36,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 37,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 38,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
            {
                id: 39,
                text: "Die Veranstaltung ist für die inhaltliche Klausurvorbereitung sehr nützlich.",
            },
        ],
    },
    {
        type: "text",
        id: 4,
        items: [
            {
                id: 40,
                text: "Besonders gut fand ich:",
            },
            {
                id: 41,
                text: "Störend fand ich:",
            },
            {
                id: 42,
                text: "Verbesserungsvorschläge:",
            },
        ],
    },
    {
        type: "age",
        id: 5,
        items: [
            {
                id: 43,
                text: "Alter: ",
            },
        ],
    },
];